import moment from "moment-mini";
import config from "../config";

function getAlmostMidnight(momentObj) {
  return momentObj
    .hour(23)
    .minute(59)
    .seconds(59);
}

export default function getForceWebPayments() {
  return config.forceWebPaymentsInApp || false;
}

export function getIsBlackFridayDay() {
  const blackFridayStartDate = getAlmostMidnight(moment("2025-11-26"));
  const blackFridayEndDate = getAlmostMidnight(moment("2025-11-28"));

  return moment().isBetween(
    blackFridayStartDate,
    blackFridayEndDate,
    undefined,
    "[]"
  );
}
export function getIsBlackWeekend() {
  const blackFridayStartDate = getAlmostMidnight(moment("2025-11-28"));
  const blackFridayEndDate = getAlmostMidnight(moment("2025-12-01"));

  return moment().isBetween(
    blackFridayStartDate,
    blackFridayEndDate,
    undefined,
    "[]"
  );
}
